export default __webpack_public_path__ + "static/media/1022.aef4a291.png";